import storeInfo from '../store'
import { ClientPropertiesType } from './types'

export const getClientProperties = () => {
  const { clientProperties }: { clientProperties: ClientPropertiesType } = storeInfo.store.getState()
  return clientProperties ?? []
}

